import { styled } from '@mui/material/styles'
import Switch from '@mui/material/Switch'

export const HuubSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  marginRight: '1rem',
  marginLeft: '1rem',
  padding: 0,
  display: 'flex',
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 15,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(9px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: 2,
    color: '#FFFFF',
    '&.Mui-checked': {
      transform: 'translateX(12px)',
      color: '#FF00B4',
      '& + .MuiSwitch-track': {
        opacity: 0.4,
        backgroundColor: theme.palette.mode === 'light' ? '#FF00B4' : '#FF00B4',
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 16 / 2,
    opacity: 0.4,
    position: 'absolute',
    backgroundColor:
      theme.palette.grey[theme.palette.mode === 'light' ? 400 : 400],
    boxSizing: 'border-box',
  },
}))
